// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.org-item[data-v-6d469934]{\n  margin: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
